let  preventPageScroll = e => {
	return e.preventDefault();
};

export default {
	prevent () {
		document.addEventListener('touchmove', preventPageScroll, false);
	},
	recover () {
		document.removeEventListener('touchmove', preventPageScroll, false);
	}	
}



// WEBPACK FOOTER //
// ./src/wc-messagebox/loading/utils/prevent-page-scroll.js